import { __assign } from 'tslib';
import { toColorString, parseToRgb } from 'polished';

var alphaHex = function alphaHex(value) {
  return function (hex) {
    return toColorString(__assign(__assign({}, parseToRgb(hex)), {
      alpha: value
    }));
  };
};

export { alphaHex };
//# sourceMappingURL=colors.js.map
